/* Copyright 2019 VMware, Inc. All rights reserved. -- VMware Confidential */

(function () {
   'use strict';
   angular.module('com.vmware.platform.ui').factory('settingsViewActionServiceHelper',
      ['actionsService', function (actionsService) {
         var getEvaluatedActions = function (objectIds, actionUids, customLabelMap) {
            return actionsService.getActions(objectIds, actionUids)
               .then(function (actionEvaluations) {
                  var actionToRenderMap = {};

                  // Build actions to render items
                  for (var i = 0; i < actionEvaluations.length; i++) {
                     var actionEvaluation = actionEvaluations[i];

                     var actionUid = actionEvaluation.action.uid;
                     var customLabel = customLabelMap[actionUid];

                     actionToRenderMap[actionUid] = {
                        label: customLabel || actionEvaluation.action.label,
                        actionId: actionEvaluation.action.uid,
                        isEnabled: actionEvaluation.available,
                        eval: actionEvaluation
                     };
                  }

                  // Add actions in the same order as specified in the
                  // directive.actions property.
                  var actionsToRender = [];
                  for (var j = 0; j < actionUids.length; j++) {
                     var auid = actionUids[j];
                     if (actionToRenderMap[auid]) {
                        actionsToRender.push(actionToRenderMap[auid]);
                     }
                  }

                  return actionsToRender;
               });
         };

         var invokeActionFromEvent = function (objectIds, action, $event, notifyActionStatusCallback) {
            // The settings view header has to provide as context of the action
            // object not array which brakes the contract of invokeAction method.
            // As I manage to verify the objectIds are not used and the change the
            // settings view header to provide object as context probably will
            // not affect other components
            var context = {
               objectIds: objectIds,
               focusTarget: $event.target,
               notifyActionStatusCallback: notifyActionStatusCallback
            };
            actionsService.invokeAction(action.eval, context);
         };

         return {
            getEvaluatedActions: getEvaluatedActions,
            invokeActionFromEvent: invokeActionFromEvent
         };
      }]);
})();